import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
// Self-hosted so no visitor IP reaches Google and font-src can stay 'self'.
// These register the families as "Bitter Variable" and "Inter Variable".
import '@fontsource-variable/bitter';
import '@fontsource-variable/inter';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply dark theme
document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
